export default __webpack_public_path__ + "static/media/330_dummy2016-nagelstudio01-mobile-de.ad5515c4.png";